import { useNavigate } from 'react-router-dom';
import './LegalPage.css';

export default function TermsPage() {
  const navigate = useNavigate();
  return (
    <div className="legal">
      <header className="legal__header">
        <button className="legal__back" onClick={() => navigate(-1)} aria-label="Terug">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 5l-7 7 7 7" />
          </svg>
        </button>
        <h1 className="legal__title">Gebruiksvoorwaarden</h1>
        <span className="legal__spacer" />
      </header>

      <main className="legal__main">
        <h2 className="legal__h1">WalkIn Gebruiksvoorwaarden</h2>
        <p className="legal__meta">Versie 1.0 — mei 2026</p>

        <h3>1. Wat is WalkIn</h3>
        <p>
          Platform dat consumenten verbindt met lokale winkels via
          locatiegebaseerde deals.
        </p>

        <h3>2. Consumentengebruik</h3>
        <p>
          Gratis, geen account, deals geldig op vermelde tijd, niet
          overdraagbaar, winkelier verantwoordelijk.
        </p>

        <h3>3. Winkeliersgebruik</h3>
        <p>
          Abonnement of tokens, deals correct en niet misleidend, WalkIn mag
          misleidende deals verwijderen.
        </p>

        <h3>4. Abonnementen en opzegging</h3>
        <p>
          Het Unlimited abonnement kan maandelijks worden opgezegd. Opzegging
          dient te geschieden vóór het einde van de lopende kalendermaand. Na
          opzegging blijft het abonnement actief tot de laatste dag van die
          maand. Daarna worden diensten afgerekend op basis van het beschikbare
          tokensaldo.
        </p>

        <h3>5. Fair use</h3>
        <p>
          Geen misbruik, geen valse QR codes, accounts kunnen geblokkeerd
          worden.
        </p>

        <h3>5. Aansprakelijkheid</h3>
        <p>
          WalkIn niet aansprakelijk voor niet-nagekomen deals, technische
          storingen of verlies.
        </p>

        <h3>6. Wijzigingen</h3>
        <p>
          WalkIn mag voorwaarden wijzigen. Winkeliers per e-mail geïnformeerd.
        </p>

        <h3>7. Toepasselijk recht</h3>
        <p>Nederlands recht. Rechtbank Amsterdam.</p>

        <h3>8. Contact</h3>
        <p>vragen@walkin.nl · WalkIn B.V. · Amsterdam</p>
      </main>
    </div>
  );
}
